const MODULE_NAME = "EVENTS_MODULE_";
const EVENTS_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const EVENTS_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const CLOSE_STARTED = MODULE_NAME + 'CLOSE_STARTED';
const CLOSE_COMPLETED = MODULE_NAME + 'CLOSE_COMPLETED';

export {
  EVENTS_FETCH_COMPLETED,
  EVENTS_FETCH_STARTED,
  CLOSE_STARTED,
  CLOSE_COMPLETED
};
